import {
  Button,
  clearSWRCache,
  InputError,
  InputText,
  Form,
  Formik,
  FormikControl,
  useRef,
  useState,
  REVIEW_EMAIL,
  PageStyle,
  ReviewEmailActions,
  useEffect,
  useSWR,
  useRouter,
  Checkbox,
  FormModalStyle,
  useTranslation,
  FormStyle,
  DefaultCheckbox,
  HoverCheckbox,
  CheckedCheckbox
} from "@/imports-files/components/review-email";
import { Close } from "@/imports-files/components/common-modal/common-modal";
export function ReviewEmail(props) {
  // --- INFO:- Clearing the SWR cache ----
  clearSWRCache("review_email_data");
  // --------------------------------------
  const {t} = useTranslation()
  const router = useRouter();
  const reviewEmailActions = new ReviewEmailActions();
  const { data, error } = useSWR("review_email_data", () => {
    return reviewEmailActions.getEmailTemplateData(
      router,
      props.emailTemplateInfo,
      props.emailTemplateInfo.template_id,
      props.emailTemplateData,
      props.type
    );
  });
  const editorBodyRef = useRef(null);
  const editorSubjectRef = useRef(null);
  const [subject, setSubject] = useState("");
  const [dataVariables, setDataVariables] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [formInitialValues, setFormInitialValues] = useState(
    REVIEW_EMAIL.email_template.formInitialValue
  );
  // const formValidation                                    =     REVIEW_EMAIL.email_template.formValidation;
  const formFieldNames = reviewEmailActions.getFormFieldsName();
  const [refreshKey, setRefreshKey] = useState(0);
  const formRef = useRef(null);
  const [disableSubmitButton, setDisabledSubmitButton] = useState(false);
  const [currentPurposeValue, setCurrentPurposeValue] = useState("");

  useEffect(() => {
    if (data) {
      if (props.emailTemplateInfo.operation_type == "edit") {
        if(props.emailTemplateInfo.type == "custom" && props.emailTemplateInfo.operation_type == "edit"){
          setCurrentPurposeValue("custom_template");
        }
        setFormInitialValues(
          reviewEmailActions.setFormInitialValues(
            data?.template_data?.data || data,
            props.type
          )
        );
      } else {
        let emptyInitialValue = {
          template: {
            master_template_id: "",
            master_template_type: "",
            master_template_attributes: {
              purpose: "",
            },
            subject: "",
            email_body: "",
            default: false,
          },
        };
        setFormInitialValues(emptyInitialValue);
      }
      setSubject(
        data?.template_data?.data?.subject_variables || data?.subject_variables
      );
      setDataVariables(
        data?.template_data?.data?.data_variables || data?.data_variables
      );
      setLoading(false);
    }
  }, [JSON.stringify(data)]);

  if (isLoading) {
    return "";
  }

  function editSubjectHtml(subject) {
    let new_subject = subject.replace(/(<([^>]+)>)/gi, "");
    new_subject = new_subject
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&rsquo;/g, "’")
      .replace(/&ouml;/g, "ö")
      .replace(/&oslash;/g, "ø")
      .replace(/&auml;/g, "ä")
      .replace(/&aring;/g, "å")
    new_subject = new_subject.replace(/\n/g, " ");
    return new_subject.trim();
  }

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal} `}>
        <div className={`${FormModalStyle.Modal__Container} `}>
          <div className={`${FormModalStyle.Modal__Container__Heading__Close}`}>
          <h1 className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}>
              {props.emailTemplateInfo.operation_type == "create"
                ? t('recruitment:templates:email:create')
                : t('recruitment:templates:email:edit')}
            </h1>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => {
              props.type == "kanban" ? props.setHideModalClass(false) : "";
              props.setReviewEmail(false);
            }}
          >
            <Close />
          </div>
        </div>
          <div className={FormModalStyle.Modal__Container__ContentSection}>
            <Formik
              initialValues={formInitialValues}
              validationSchema={reviewEmailActions.formValidation(
                currentPurposeValue
              )}
              innerRef={formRef}
              onSubmit={(values) => {
                if (props.type == "kanban") {
                  values.job_stage_id = props.emailTemplateInfo.job_stage_id;
                  values.template.subject = editSubjectHtml(
                    values.template.subject
                  );
                  reviewEmailActions.saveEmailTemplate(
                    values,
                    props.job_id,
                    router,
                    props.setHideModalClass,
                    props.setReviewEmail,
                    formRef,
                    setDisabledSubmitButton
                  );
                } else {
                  values.template.subject = editSubjectHtml(
                    values.template.subject
                  );
                  reviewEmailActions.submitReviewEmail(
                    values,
                    props.setReviewEmail,
                    props.emailTemplateInfo,
                    props.emailTemplateData,
                    props.setEmailTemplateData,
                    props.setFlagForRender,
                    formRef,
                    router,
                    setDisabledSubmitButton
                  );
                }
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol}`}>
                    <label className={`${FormStyle.Form__FloatingLabel}`} style={InputText(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.master_template_id}`
                      )}>
                     <span className={`red-color`}>*</span>&nbsp;{t('label:purpose')}
                    </label>
                  </div>

                  <div className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}>

                   { props.emailTemplateInfo.type == "custom" && props.emailTemplateInfo.operation_type == "edit" ?
                    <FormikControl
                          control="input"
                          type="text"
                          formik={formik}
                          errorClass={FormModalStyle.Form__Error}
                          placeholder   =   {t('label:purpose')}
                          className={`${FormModalStyle.Form__Input} width100 thresholdmodl`}
                          name={
                            formFieldNames["type"] +
                            "." +
                            formFieldNames["purpose"]
                          }
                          style={InputError(
                            formik,
                            `${formFieldNames.type}.${formFieldNames.purpose}`
                          )}
                      ></FormikControl>
                    : <FormikControl
                      control="select"
                      type="text"
                      formik={formik}
                      errorClass={FormModalStyle.Form__Error}
                      default={
                        props.type == "kanban"
                          ? "0"
                          : formInitialValues.template.master_template_id
                      }
                      disabled={
                        props.emailTemplateInfo.operation_type != "create" &&
                        props.type != "kanban"
                          ? true
                          : false
                      }
                      s
                      className={`${FormModalStyle.Form__Input} ${FormStyle.Form__Input} thresholdmodl`}
                      name={
                        formFieldNames["type"] +
                        "." +
                        formFieldNames["master_template_id"]
                      }
                      options={
                        props.type == "kanban"
                          ? reviewEmailActions.kanbanPurposeList(
                              props.emailTemplateData
                            )
                          : reviewEmailActions.getPurposeOptions(
                              props.emailTemplateInfo.operation_type == "create"
                                ? data?.purpose_list
                                : props.emailTemplateData,
                              props.type, t
                            ).options
                      }
                      style={InputError(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.master_template_id}`
                      )}
                      onChange={(option) => {
                        if (props.type == "kanban") {
                          setCurrentPurposeValue(option.value);
                          reviewEmailActions.setSystemTemplate(
                            option,
                            formik,
                            formFieldNames,
                            setSubject,
                            setDataVariables,
                            setRefreshKey,
                            props.emailTemplateData.templates
                          );
                        } else {
                          setCurrentPurposeValue(option.value);
                          reviewEmailActions.getSystemEmailTemplate(
                            option,
                            formik,
                            formFieldNames,
                            setSubject,
                            setDataVariables,
                            setRefreshKey,
                            t
                          );
                        }
                      }}
                    ></FormikControl>
                  }
                  </div>
                  {formik.values[formFieldNames["type"]][
                    formFieldNames["master_template_id"]
                  ] == "add_custom" && (
                    <div>
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol}`}>
                        <label
                           className={`${FormStyle.Form__FloatingLabel}`} style={InputText(
                            formik,
                            `${formFieldNames.type}.${formFieldNames.master_template_attributes}.${formFieldNames.purpose}`
                          )}>
                          <span className={`red-color`}>*</span>&nbsp;
                         {t('label:new_purpose')}
                        </label>
                      </div>

                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                      >
                        <FormikControl
                          control="input"
                          type="text"
                          formik={formik}
                          errorClass={FormModalStyle.Form__Error}
                          placeholder   =   {t('label:purpose')}
                          className={`${FormModalStyle.Form__Input} ${FormStyle.Form__Input} width100 thresholdmodl`}
                          name={
                            formFieldNames["type"] +
                            "." +
                            formFieldNames["master_template_attributes"] +
                            "." +
                            formFieldNames["purpose"]
                          }
                          style={InputError(
                            formik,
                            `${formFieldNames.type}.${formFieldNames.master_template_attributes}.${formFieldNames.purpose}`
                          )}
                        ></FormikControl>
                      </div>
                    </div>
                  )}
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol}`}
                  >
                    <label
                      className={
                        `${FormStyle.Form__FloatingLabel}`
                      } style={InputText(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.subject}`
                      )}>
                      <span className={`red-color`}>*</span>&nbsp;
                     {t('label:subject')}
                    </label>
                  </div>

                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <FormikControl
                      id="email_template_subject"
                      key={refreshKey}
                      apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                      control="customEditor"
                      formik={formik}
                      name = {`${formFieldNames.type}.${formFieldNames.subject}`}
                      onInit={(evt, editor) =>
                        (editorSubjectRef.current = editor)
                      }
                      textareaName={`${formFieldNames.type}.${formFieldNames.subject}`}
                      identifierClass="emailTemplateSubject"
                      style={InputError(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.subject}`
                      )}
                      value={
                        formik.values[`${formFieldNames.type}`][
                          `${formFieldNames.subject}`
                        ]
                      }
                      onEditorChange={(value, editor) => {
                        formik.status
                          ? (formik.status[`${formFieldNames.type}`][
                              `${formFieldNames.subject}`
                            ] = "")
                          : "";
                        // let subject_value = editor.getContent({format: 'text'});
                        formik.setFieldValue(
                          `${formFieldNames.type}.${formFieldNames.subject}`,
                          value
                        );
                      }}
                      init={{
                        height: 50,
                        resize: false,
                        menubar: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "print",
                          "preview anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "paste",
                          "help",
                          "wordcount",
                          "autoresize",
                          "noneditable",
                        ],
                        toolbar: "tokens",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        newline_behavior: "block",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        setup: (editor) => {
                          // Register a custom toolbar menu button to insert tokens
                          // https://www.tiny.cloud/docs/ui-components/typesoftoolbarbuttons/#menubutton
                          editor.ui.registry.addMenuButton("tokens", {
                            text: t('label:data_tags'),
                            tooltip: t('label:insert_token'),
                            fetch: (callback) => {
                              var items = subject.map((subject) => {
                                return {
                                  type: "menuitem",
                                  text: subject.text,
                                  onAction: () => {
                                    // Insert content at the location of the cursor.
                                    // https://www.tiny.cloud/docs/api/tinymce/tinymce.editor/#insertcontent
                                    editor.insertContent(subject.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                          editor.on("keydown", function (e) {
                            if (e.keyCode == 13) {
                              e.preventDefault();
                            }
                          });
                        },
                        paste_preprocess: function (plugin, args) {
                          args.content = args.content.replace(
                            /(<([^>]+)>)/gi,
                            ""
                          );
                        },
                      }}
                    />
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol}`}
                  >
                    <label
                      className={
                       `${FormStyle.Form__FloatingLabel}`
                      } style={InputText(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.body}`
                      )}>
                      <span className={`red-color`}>*</span>&nbsp;
                      {t('label:email_body')}
                    </label>
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <FormikControl
                      id="email_template_body"
                      key={refreshKey}
                      control="customEditor"
                      formik={formik}
                      onInit={(evt, editor) => (editorBodyRef.current = editor)}
                      textareaName={`${formFieldNames.type}.${formFieldNames.body}`}
                      identifierClass="emailTemplateBody"
                      style={InputError(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.body}`
                      )}
                      value={
                        formik.values[`${formFieldNames.type}`][
                          `${formFieldNames.body}`
                        ]
                      }
                      onEditorChange={(value) => {
                        formik.status
                          ? (formik.status[`${formFieldNames.type}`][
                              `${formFieldNames.body}`
                            ] = "")
                          : "";
                        formik.setFieldValue(
                          `${formFieldNames.type}.${formFieldNames.body}`,
                          value
                        );
                      }}
                      init={{
                        height: 500,
                        menubar: false,
                        resize: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                          "noneditable",
                        ],
                        toolbar:
                          "undo redo | blocks | " +
                          "bold italic backcolor | link |  alignleft aligncenter " +
                          "alignright alignjustify | tokens",

                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        allow_html_in_named_anchor: true,
                        setup: (editor) => {
                          // Register a custom toolbar menu button to insert tokens
                          // https://www.tiny.cloud/docs/ui-components/typesoftoolbarbuttons/#menubutton
                          editor.ui.registry.addMenuButton("tokens", {
                            text: t('label:data_tags'),
                            tooltip: t('label:insert_token'),
                            fetch: (callback) => {
                              var items = dataVariables.map((dataVariable) => {
                                return {
                                  type: "menuitem",
                                  text: dataVariable.text,
                                  onAction: () => {
                                    // Insert content at the location of the cursor.
                                    // https://www.tiny.cloud/docs/api/tinymce/tinymce.editor/#insertcontent
                                    editor.insertContent(dataVariable.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                        },
                      }}
                    />
                  </div>
                  {router.query.email_type == "custom" &&
                    formik.values[`${formFieldNames["type"]}`][
                      "master_template_type"
                    ] == "MasterTemplate" && (
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                      >
                        <div className={`${FormStyle.Form__LabelCheck} Dpflex16 Mui__CustomCheckbox`}>
                            <Checkbox
                              name={
                                formFieldNames["type"] +
                                "." +
                                formFieldNames["default"]
                              }
                              onChange={(event) => {
                                formik.setFieldValue(
                                  `${formFieldNames.type}.${formFieldNames.default}`,
                                  event.target.checked
                                );
                              }}
                              defaultChecked={
                                formInitialValues.template.default == "Yes"
                              }
                              icon = {<DefaultCheckbox/>}
                              checkedIcon = {<CheckedCheckbox/>}
                            />
                            {" "}
                            {t('checkbox:set_as_default')}
                        </div>
                      </div>
                    )}
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={FormModalStyle.secondarybtnborder}
                      onClick={() => {
                        props.type == "kanban"
                          ? props.setHideModalClass(false)
                          : "";
                        props.setReviewEmail(false);
                      }}
                    >
                     {t('button:cancel')}
                    </Button>
                    {props.type != "kanban" &&
                      router.query.email_type != "custom" && (
                        <Button
                          buttonstyle={FormModalStyle.secondarybtnborder}
                          onClick={() => {
                            reviewEmailActions.resetTemplate(
                              props.emailTemplateInfo.template_id,
                              props.setReviewEmail
                            );
                          }}
                        >
                         {t('button:reset')}
                        </Button>
                      )}
                    <Button
                      buttonstyle={FormModalStyle.primarybtn}
                      type="submit"
                      disabled={disableSubmitButton}
                    >
                      {t('button:save')}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
